import UnconfirmedEmailBannerLexique from 'locales/types/components/organisms/UnconfirmedEmailBanner';

export const unconfirmedEmailBannerLexique: UnconfirmedEmailBannerLexique = {
    description: 'Validate your inscription by clicking on the link sent at',
    resend: 'Send it again?',
    emailResent: 'An email has been sent to:',
};

export default unconfirmedEmailBannerLexique;
